import Vue from 'vue'
import axios from 'axios'
import dayjs from 'dayjs'
import Configuration from '@/utilities/service/Configuration'
import WeatherPlugin from '@/utilities/plugin/weather'
import VisualCrossingApi from '@/utilities/weather/services/visualCrossing/VisualCrossingApi'
import OpenWeatherApi from '@/utilities/weather/services/openWeatherApi/OpenWeatherApi'

const API_KEYS = {
  visualCrossingApi: 'USH9BVQZZ6XWCCY7PF5BXYC3P', // Configuration.value('visualCrossingApiKey') ?? '',
  openWeatherApi: 'afb2f8ecd10702befa2bf8b7e827dd4e', // Configuration.value('openWeatherApiKey') ?? '',
}

const options = {
  services: [new OpenWeatherApi(API_KEYS.openWeatherApi, axios, dayjs()), new VisualCrossingApi(API_KEYS.visualCrossingApi, axios)],
}

export default Vue.use(WeatherPlugin, options)
